import React from "react";
import { money, precioDe } from "./boleteraHelper";

// Tocar una tarifa suma un boleto. Sin precio para el trayecto, no se puede vender.
const Tarifas = ({ catalogo, zonaDestino, zonaOrigenId, qty, onAdd, disabled }) => (
  <div className="boletera-tarifas">
    {(catalogo?.tipos ?? []).map((tipo) => {
      const precio = precioDe(catalogo, zonaDestino, tipo, zonaOrigenId);
      const sinPrecio = precio == null;
      const cantidad = qty[tipo.id] ?? 0;

      return (
        <button
          key={tipo.id}
          type="button"
          className="boletera-tarifa"
          disabled={disabled || sinPrecio}
          title={sinPrecio ? "Sin tarifa configurada para este trayecto" : undefined}
          onClick={() => onAdd(tipo.id, 1)}
        >
          <span style={{ fontWeight: 600, fontSize: "13.5px" }}>{tipo.nombre}</span>
          <span style={{ fontSize: "17px", fontWeight: 700 }}>
            {sinPrecio ? "—" : money(precio)}
          </span>
          {cantidad > 0 && <span className="boletera-badge">×{cantidad}</span>}
        </button>
      );
    })}
  </div>
);

export default Tarifas;
